import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { PatientManagementSystemComponent } from './patient-management-system/patient-management-system.component';
import { RulesExecutionSystemComponent } from './rules-execution-system/rules-execution-system.component';
import { ReminderSetsComponent } from './reminder-sets/reminder-sets.component';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { AllCommunityModule, ModuleRegistry, ClientSideRowModelModule } from 'ag-grid-community';
import { CommonModule } from '@angular/common';
import { LabelModule } from '@wuitk/angular/components/label';
import { PatientManagementSystemAggregatorComponent } from './patient-management-system-aggregator/patient-management-system-aggregator.component';
import { PatientSearchComponent } from './patient-search/patient-search.component';
import { TabsModule } from '@wuitk/angular/components/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { ComponentsRoutingModule } from './components-routing.module';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '../shared/shared.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ComplianceRulesComponent } from './compliance-rules/compliance-rules.component';
import { RulesetsComponent } from './rulesets/rulesets.component';
// import { ReminderSetsComponent } from './reminder-sets/reminder-sets.component';
// import { PatientCarePlanComponent } from './patient-care-plan/patient-care-plan.component';
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { AdherenceProfilerComponent } from './adherence-profiler/adherence-profiler.component';
import { MatDividerModule } from '@angular/material/divider';
import { EquipmentComponent } from '../equipment/equipment.component';
import { DevicesComponent } from './devices/devices.component';
import { AccessoriesComponent } from './accessories/accessories.component';
import { OrganizationManagementComponent } from './organization-management/organization-management.component';
import { AddUserComponent } from './organization-management/user-management/add-user/add-user.component';
import { NotAuthorizedComponent } from './not-authorized.component';
import { EmptyComponent } from './empty.component';
import { PatientCarePlanComponent } from './patient-care-plan/patient-care-plan.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdherenceProfilerComponent } from './adherence-profiler/adherence-profiler.component';
import { SrcRulesComponent } from './src-rules/src-rules.component';
import { PatientRulesAssignmentComponent } from './patient-rules-assignment/patient-rules-assignment.component';
ModuleRegistry.registerModules([AllCommunityModule, ClientSideRowModelModule]);

@NgModule({
  imports: [
    RouterModule,
    ComponentsRoutingModule,
    AgGridAngular,
    AgGridModule,
    CommonModule,
    LabelModule,
    TabsModule,
    MatTabsModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    SharedModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    MatDividerModule,
    AddUserComponent,
    ReactiveFormsModule
  ],
  declarations: [
    PatientManagementSystemComponent,
    RulesExecutionSystemComponent,
    PatientManagementSystemAggregatorComponent,
    PatientSearchComponent,
    ComplianceRulesComponent,
    RulesetsComponent,
    // ReminderSetsComponent,
    AdherenceProfilerComponent,
    PatientCarePlanComponent,
    EquipmentComponent,
    DevicesComponent,
    AccessoriesComponent,
    OrganizationManagementComponent,
    PatientSearchComponent,
    ComplianceRulesComponent,
    RulesetsComponent,
    PatientRulesAssignmentComponent,
    SrcRulesComponent,
    AdherenceProfilerComponent,
    PatientCarePlanComponent,
    NotAuthorizedComponent,
    EmptyComponent,
    ReminderSetsComponent
  ],
  schemas: [NO_ERRORS_SCHEMA],
  exports: [PatientManagementSystemComponent, RulesExecutionSystemComponent, PatientManagementSystemAggregatorComponent, OrganizationManagementComponent, PatientSearchComponent, PatientCarePlanComponent]
})
export class ComponentsModule { }
